import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { AppBar, Tabs, Tab, Box } from '@material-ui/core';
import './App.css';

import { First } from './components/First/First';
import { Second } from './components/Second/Second';
import { Third } from './components/Third/Third';
import { Fourth } from './components/Fourth/Fourth';
import { Fifth } from './components/Fifth/Fifth';
import { Sixth } from './components/Sixth/Sixth';

function TabPanel(props) {
  const { children, value, index, } = props;

  return (
    <>
      {value === index && (
        <Box >
          <div>
            {children}
          </div>
        </Box>
      )}
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function App() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static" >
        <Tabs value={value} onChange={handleChange} >
          <Tab label="АНКЕТА УЧАСТНИКА ПЕРВОГО ТУРА" />
          <Tab label="АНКЕТА ЛАУРЕАТА" />
          <Tab label="АНКЕТА ЭКСПЕРТА ПЕРВОГО ТУРА" />
          <Tab label="АНКЕТА ЭКСПЕРТА БОЛЬШОГО ЖЮРИ" />
          <Tab label="АНКЕТА ЭКСПЕРТА РОДИТЕЛЬСКОГО и УЧЕНИЧЕСКОГО ЖЮРИ" />
          <Tab label="АНКЕТА СОПРОВОЖДАЮЩЕГО" />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <Third />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <First />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Fourth />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <Fifth />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <Sixth />
      </TabPanel>
      <TabPanel value={value} index={5}>
        <Second />
      </TabPanel>
    </div>
  );

}
